import Auth from '../services/auth';
import store from '../store/configure-store';
import { orgIdSelector } from '../store/selectors';
import { setItem } from '../utils/storage';
import urlIsSafeToNavigate from '../utils/url';
import paths from './paths';

const response = (action, data) => ({ action, data });

const createRedirectToQueryParam = () => {
  const { pathname, search } = window.location;
  if (pathname === '/terms-and-conditions' || pathname === '/welcome') {
    return '';
  }
  const params = [];
  params.push(pathname);
  params.push(search);
  setItem('return_to', encodeURIComponent(params.filter((param) => param).join('')));
  return `?returnTo=${encodeURIComponent(params.filter((param) => param).join(''))}`;
};

export function needAuth(route) {
  if (Auth().isAuthenticated()) {
    return response('pass', route);
  }
  if (urlIsSafeToNavigate(window.location.pathname + window.location.search)) {
    return response('redirect', paths.login + createRedirectToQueryParam());
  }
  return response('redirect', paths.login);
}

export function needRedirectCauseHasOrgId(route) {
  const orgId = orgIdSelector(store.getState());
  if (!orgId) {
    return response('pass', route);
  }
  return response('redirect', paths.participants);
}

export function needUnAuth(route) {
  if (!Auth().isAuthenticated()) {
    return response('pass', route);
  }
  return response('redirect', paths.participants);
}

export function needOrgId(route) {
  const orgId = orgIdSelector(store.getState());
  const { user } = store.getState().app;
  if (Object.entries(user).length === 0) {
    return response('block', null);
  }
  if (orgId) {
    return response('pass', route);
  }
  return response('redirect', paths.welcome);
}
